import { Loader2 } from 'lucide-react'

/** Full-viewport centered spinner for route/page loading states. */
export function FullScreenLoader() {
  return (
    <div className="h-dvh bg-background flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  )
}
